import Badges from './badges'

export default Badges;